module.exports = __webpack_public_path__ + "static/media/instragram2.b86ebc87.jpg";